import Sidebar from "@/v2-backoffice-client/components/sidebar"
import NotificationUnreadCountBadge from "@/v2-backoffice-client/notification/unreadCount/NotificationUnreadCountBadge"
import { useNotificationCenter } from "@/v2-backoffice-client/notification/NotificationCenterProvider"
import { useStaffNotificationStream } from "@/v2-backoffice-client/notification/stream/notification.stream"

/**
 * The staff notification bell in the sidebar's bottom section — toggles
 * the notification center dock (NotificationCenterDock, rendered beside
 * the sidebar). Always mounted, so this is also where the SSE stream
 * lives: the unread badge stays live even while the dock is closed.
 */
function NotificationCenter() {
  const { isOpen, toggle } = useNotificationCenter()

  useStaffNotificationStream()

  return (
    <Sidebar.Item
      iconSrc="bell"
      isActive={isOpen}
      badge={<NotificationUnreadCountBadge />}
      data-feature-code="UI_BackofficeNotifications_Sidebar_Bell"
      onClick={toggle}
    >
      Notifications
    </Sidebar.Item>
  )
}

export default NotificationCenter
